// src/routes/marketplace/marketplace-prelicense-routes.tsx
import { lazy } from 'react';
import type { RoutesProps } from '../routes';
import {
    FaSearch,
    FaFileContract,
    FaGavel,
} from 'react-icons/fa';
import { BiTrendingUp } from 'react-icons/bi';

// Pre-license components
const ExternalWorkSearch = lazy(() => import('@/pages/marketplace/external-works/ExternalWorkSearch'));
const EnhancedPreLicenseForm = lazy(() => import('@/pages/marketplace/pre-license/EnhancedPreLicenseForm'));
const PreLicenseTracker = lazy(() => import('@/pages/marketplace/pre-license/PreLicenseTracker'));

// Pre-license routes
export const marketplacePreLicenseRoutes: RoutesProps[] = [
    {
        path: '/marketplace/external-works/search',
        name: 'Tìm kiếm tác phẩm quốc tế',
        element: <ExternalWorkSearch />,
        roles: ['right_owner', 'licensee'],
        icon: FaSearch,
    },
    {
        path: '/marketplace/pre-license/form',
        name: 'Yêu cầu Pre-License',
        element: <EnhancedPreLicenseForm />,
        roles: ['right_owner', 'licensee'],
        icon: FaFileContract,
    },
    {
        path: '/marketplace/pre-license/tracker',
        name: 'Theo dõi Pre-License',
        element: <PreLicenseTracker />,
        roles: ['right_owner', 'licensee'],
        icon: BiTrendingUp,
    },
];

// Navigation structure for pre-license system
export const marketplacePreLicenseNavigationStructure = {
    externalSearch: {
        key: 'external-work-search',
        translationKey: 'marketplace.externalSearch',
        path: '/marketplace/external-works/search',
        icon: FaSearch,
        roles: ['right_owner', 'licensee'],
    },
    preLicenseForm: {
        key: 'pre-license-form',
        translationKey: 'marketplace.preLicenseForm',
        path: '/marketplace/pre-license/form',
        icon: FaFileContract,
        roles: ['right_owner', 'licensee'],
    },
    preLicenseTracker: {
        key: 'pre-license-tracker',
        translationKey: 'marketplace.preLicenseTracker',
        path: '/marketplace/pre-license/tracker',
        icon: BiTrendingUp,
        roles: ['right_owner', 'licensee'],
    },
};

// Helper functions
export const canAccessPreLicense = (userRoles: string[]): boolean => {
    const allowedRoles = ['right_owner', 'licensee'];
    return userRoles.some(role => allowedRoles.includes(role));
};

export const getPreLicenseMenuGroup = (userRoles: string[]) => {
    if (!canAccessPreLicense(userRoles)) return null;

    return {
        key: 'marketplace-pre-license',
        translationKey: 'marketplace.preLicense',
        icon: FaGavel,
        children: [
            marketplacePreLicenseNavigationStructure.externalSearch,
            marketplacePreLicenseNavigationStructure.preLicenseForm,
            marketplacePreLicenseNavigationStructure.preLicenseTracker,
        ]
    };
};

export default marketplacePreLicenseRoutes;